const fileSize = (size: string) => {
    const sizeInFloat = parseFloat(size);
    if (Math.floor(sizeInFloat) === 0) {
        const sizeInKB = sizeInFloat * 1024;
        return `${sizeInKB.toFixed(2)} KB`;
    }
    return `${sizeInFloat.toFixed(2)} MB`;
};
export default fileSize;
